import React from "react";
import { GithubFilled, InstagramFilled, LayoutFilled } from "@ant-design/icons";
import classNames from "classnames";
import styles from "../styles/ContractMe.module.scss";
import SHADOW_PITCHER from "../assets/images/shadow-pitcher.png";
import FLOWER_PITCHER from "../assets/images/flower-pitcher.png";
import IMAGE_PROFILE from "../assets/images/image-profile-watcharapol.png";

const ContractMe = () => {
  return (
    <>
      <div className="max-w-[1280px] w-full flex flex-col sm:px-[15px]">
        <div>
          <h2 className="text-[32px] font-bold text-custom-secondary-75 mb-0">
            Contact
          </h2>
          <h3 className="text-[18px] text-custom-primary-100">
            Have some interests or questions?
          </h3>
        </div>

        <div className="grid grid-cols-12 gap-[20px] mx-[50px] mt-[30px] sm:flex sm:flex-col ss:mx-0">
          <div className="flex flex-col items-center justify-center  gap-[10px] rounded-[15px] w-full col-span-7">
            <div className="h-[470px] md:h-[400px] bg-custom-primary-100 rounded-[15px_15px_5px_5px] w-full p-[20px] flex justify-center items-center gap-[20px] xs:flex-col">
              <div className="w-[45%] flex justify-center items-center xs:w-full">
                <img
                  src={IMAGE_PROFILE}
                  className="h-[200px] w-[200px] md:h-[150px] md:w-[150px] rounded-[999px] "
                />
              </div>
              <div className="w-[55%] flex flex-col justify-center xs:w-full xs:items-center xs:text-center">
                <div>
                  <h2 className="text-[24px] font-bold text-custom-secondary-75 mb-[3px] leading-[25px]">
                    A Dev and Design
                  </h2>
                  <h3 className="text-[12px] text-custom-secondary-50 leading-[15px]">
                    Contact me if you're interested.
                  </h3>
                </div>

                <ul className="text-[10px] text-custom-secondary-50 mt-[10px]">
                  <li>benz.wachara1976@gmail.com</li>
                  <li>GitHub : github.com/BenzWachara</li>
                  <li>IG : watchara.workspace</li>
                  <li>Frontend Mentor : @BenzWachara</li>
                </ul>

                <div className="flex gap-[20px] mt-[25px]">
                  <a href="https://github.com/BenzWachara" target="_blank">
                    <GithubFilled className="text-[18px] text-custom-secondary-75 cursor-pointer duration-200 hover:scale-150" />
                  </a>
                  <a
                    href="https://www.instagram.com/wachara.workspace/"
                    target="_blank"
                  >
                    <InstagramFilled className="text-[18px] text-custom-secondary-75 cursor-pointer duration-200 hover:scale-150" />
                  </a>
                  <a
                    href="https://www.frontendmentor.io/profile/BenzWachara"
                    target="_blank"
                  >
                    <LayoutFilled className="text-[18px] text-custom-secondary-75 cursor-pointer duration-200 hover:scale-150" />
                  </a>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-center h-[30px] bg-custom-primary-100 rounded-[5px_5px_15px_15px] w-full relative">
              <p className="mb-0 font-semibold text-[11px] text-custom-secondary-75 tracking-[2px]">
                ©DevAndDesign by Watcharapol
              </p>

              <img
                src={SHADOW_PITCHER}
                className="hidden sm:block ss:hidden w-[70px] absolute ml-[50px] bottom-[-10px] right-[20px] opacity-70"
              />
              <img
                src={FLOWER_PITCHER}
                className="hidden sm:block w-[70px] absolute bottom-[-20px] right-[-20px]"
              />
            </div>
          </div>

          <div className="flex flex-row gap-[20px] col-span-5 sm:hidden">
            <div className="bg-custom-primary-100 relative rounded-[15px] w-[80%] flex flex-col justify-end">
              <img
                src={SHADOW_PITCHER}
                className="w-[170px] ml-[50px] md:w-[150px]"
              />
              <img
                src={FLOWER_PITCHER}
                className="w-[180px] absolute bottom-[-60px] right-[-70px] md:w-[160px]"
              />
            </div>
            <div className="w-[20%] sm:hidden"></div>
          </div>
        </div>
      </div>
      <div className="mt-[100px]"></div>
    </>
  );
};

export default ContractMe;
